import React, {useEffect} from "react";
import breadcrumbSchema from "../Schemas/breadcrumbSchema";
import heroImg from '../Images/services-hero.webp'
import SchemaMarkup from "../Components/SchemaMarkup";
import Header from "../Components/Header";
import BreadcrumbMain from "../Components/BreadcrumbMain";
import Services from "../Components/Services";
import StatsBox from "../Components/StatsBox";
import ProcessSection from "../Components/Process";
import AwardsSection from "../Components/AwardsSection";
import Cta from "../Components/Cta";

const ServicesLeederville = () => {

useEffect(() => {
    document.title =
    "Property Settlement Services Leederville | LDL Settlement";
        
    const metaDesc = document.querySelector("meta[name='description']");
    if (metaDesc) {
    metaDesc.setAttribute(
    "content",
    "Professional settlement agents in Leederville, WA, for residential and commercial property settlements. Get reliable guidance from LDL Settlement Services."
    );
}
        
    const canonical = document.querySelector("link[rel='canonical']");
    if (canonical) {
    canonical.setAttribute("href", "https://ldlsettlementservices.com.au/services/leederville/");
}
        
    const ogTitle = document.querySelector("meta[property='og:title']");
    if (ogTitle) {
    ogTitle.setAttribute(
    "content",
    "Property Settlement Services Leederville | LDL Settlement"
    );
}
        
    const ogDesc = document.querySelector("meta[property='og:description']");
    if (ogDesc) {
    ogDesc.setAttribute(
    "content",
    "Professional settlement agents in Leederville, WA, for residential and commercial property settlements. Get reliable guidance from LDL Settlement Services."
    );
}
        
    const ogUrl = document.querySelector("meta[property='og:url']");
    if (ogUrl) {
    ogUrl.setAttribute("content", "https://ldlsettlementservices.com.au/services/leederville/");
}
        
    const ogImage = document.querySelector("meta[property='og:image']");
    if (ogImage) {
    ogImage.setAttribute(
    "content",
    "https://ldlsettlementservices.com.au/Images/service-img.webp"
    );
}
        
    const twitterTitle = document.querySelector("meta[name='twitter:title']");
    if (twitterTitle) {
    twitterTitle.setAttribute(
    "content",
    "Property Settlement Services Leederville | LDL Settlement"
    );
}
        
    const twitterDesc = document.querySelector(
    "meta[name='twitter:description']"
);
    if (twitterDesc) {
    twitterDesc.setAttribute(
    "content",
    "Professional settlement agents in Leederville, WA, for residential and commercial property settlements. Get reliable guidance from LDL Settlement Services."
    );
}
        
    const twitterImage = document.querySelector("meta[name='twitter:image']");
    if (twitterImage) {
    twitterImage.setAttribute(
    "content",
    "https://ldlsettlementservices.com.au/Images/service-img.webp"
    );
    }
}, []);

 const breadcrumbs = breadcrumbSchema([
  {
    name: "Home",
    url: "https://ldlsettlementservices.com.au/"
  },
 {
    name: "Services in Leederville"
  }
]);

    return (
        <>
         <SchemaMarkup schema={breadcrumbs} />

        <Header
        showBreadcrumb={true}
        pageName="Services in Leederville"
      />

      <BreadcrumbMain
      subTitle="OUR SERVICES"
      title="Property Settlement Services in Leederville"
      description="Whether you are buying, selling or transferring property, our experienced settlement team helps make the process simple, clear and stress-free."
      image={heroImg}
      showIcons={false}
      extraText="We provide professional property settlement and conveyancing support across Leederville and Western Australia, managing the details with care, accuracy and efficiency."
    />

     {/**SERVICES GRID */}
    <Services
      isSlider={false}
      basePath="/services/leederville"
      sliderHeading={<>Our Settlement Services<span> in Leederville</span></>}
      desc="Professional settlement solutions for residential, commercial and property transactions in Leederville and across Western Australia. We provide reliable, transparent and client-focused support."
    />

     {/**STATS SECTION */}
    <StatsBox
      heading="A Proven Track Record in Leederville Property Settlements"
      desc="When it comes to property transactions, trust and accuracy matter. Our settlement team focuses on clear communication, careful documentation and efficient coordination to help make every transaction as smooth as possible. With experience across a wide range of property matters, we support clients throughout Leederville and across Western Australia."
    />

    {/**HOW WE MAKE IT EASY FOR YOU SECTION */}
    <ProcessSection
        heading={<>How We Make Property <span>Settlement Easy for You</span></>}
        desc="We streamline the settlement process through clear communication, expert guidance and dedicated support, helping you understand each step from start to finish."
    />

    {/**AWARDS SECTION */}
   <AwardsSection
     heading="Accredited, Certified, and Award-Winning Settlement Services"
     desc="At LDL Settlement Services, we value professional standards, reliable service and ongoing industry development. Our focus is on providing clear, dependable support and helping clients navigate property settlements with confidence."
   />

    {/**CTA SECTION */}
    <Cta
      heading="Ready for a Smooth, Hassle-Free Settlement in Leederville?"
      desc="Let our experienced settlement team guide you through the process with clear communication, careful documentation and personalised support."
    />
        </>
    )
}
export default ServicesLeederville;